import type { IService } from "../../../../types/package";

export interface RoleOption {
  id: number;
  name: string;
  description?: string;
}

/** One editable crew-requirement row in the builder. */
export interface CrewRequirementDraft {
  key: string; // stable client id for list rendering
  role_id: number | "";
  role_name?: string;
  quantity: number;
  is_mandatory: boolean;
}

export interface PackageBuilderState {
  name: string;
  package_type: string;
  description: string;
  base_price: string;
  show_on_public: boolean;
  is_active: boolean;
  funeral_home_id: string;
  base_services: IService[];
  crew_requirements: CrewRequirementDraft[];
  logo_file: File | null;
  logo_preview: string | null;
}

export const PACKAGE_TYPES: { value: string; label: string }[] = [
  { value: "Funeral", label: "Funeral" },
  { value: "FuneralHome", label: "Funeral Home" },
  { value: "Memorial", label: "Memorial" },
  { value: "Church", label: "Church" },
  { value: "Conference", label: "Conference" },
  { value: "Event", label: "Event" },
  { value: "Other", label: "Other" },
];

export const emptyState = (): PackageBuilderState => ({
  name: "",
  package_type: "Funeral",
  description: "",
  base_price: "",
  show_on_public: false,
  is_active: true,
  funeral_home_id: "",
  base_services: [],
  crew_requirements: [],
  logo_file: null,
  logo_preview: null,
});

export const newRequirementRow = (): CrewRequirementDraft => ({
  key: `req-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
  role_id: "",
  quantity: 1,
  is_mandatory: true,
});
